<div *ngIf="showSpinner$ | async" class="backoffice-overlay">
    <mat-spinner mode="indeterminate" class="backoffice-center"></mat-spinner>
</div>
